/**
 * Generate a URL-friendly slug from brand name and product name.
 * Used for SEO-friendly product URLs.
 * The slug is cosmetic — routing uses the UUID.
 */
export function productSlug(brandName: string, productName: string): string {
  return `${brandName}-${productName}`
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/** Generate a URL-friendly slug from a brand name. */
export function brandSlug(brandName: string): string {
  return brandName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/** Build a product URL with SEO slug appended. */
export function productUrl(productId: string, brandName?: string, productName?: string): string {
  if (brandName && productName) {
    return `/products/${productId}/${productSlug(brandName, productName)}`;
  }
  return `/products/${productId}`;
}

/** Build a brand page URL. */
export function brandUrl(brandName: string): string {
  return `/brands/${brandSlug(brandName)}`;
}
